<script>
  import {
    VRadioGroup
  } from 'vuetify/lib'
  export default {
    name: 'wh-radio-group',
    extends: VRadioGroup
  };
</script>